import { Component, output } from '@angular/core';
import { RouterLink } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { UserSessionService } from '../../../../core/services/user-session.service';
import { AvatarComponent } from '../../../../parts/avatar/avatar.component';
import { AvatarConstants } from '../../../../core/constants/avatar.constants';
import { TooltipDirective } from '../../../../core/directives/tooltip.directive';

@Component({
	selector: 'ms-top-menu-user',
	imports: [FontAwesomeModule, AvatarComponent, RouterLink, TooltipDirective],
	templateUrl: './top-menu-user.component.html'
})
export class TopMenuUserComponent {
	public avatarSize = AvatarConstants.SIZE().TOP_MENU_PROFILE;
	public avatarDropdownMenuHeaderSize = AvatarConstants.SIZE().TOP_MENU_DROPDOWN_PROFILE;
	public avatarShape = AvatarConstants.SHAPE().TOP_MENU_PROFILE;
	public avatarAdditionalAttributes = AvatarConstants.ADDITIONAL_ATTRIBUTES().TOP_MENU_PROFILE;

	public logOutRequested = output<void>();

	constructor(public userSessionService: UserSessionService) {}
}
